export default class Beneficiary {
  id = null;
  givenName = '';
  familyName = '';
  relationship = 'spouse';
  dateOfBirth = '';
  socialSecurityNumber = '';
  beneficiaryType = '';
  sharePercent = 0;
  address = {
    streetAddress: null,
    streetAddress2: null,
    city: null,
    state: null,
    postalCode: null,
    country: 'USA',
  };

  constructor(attributes) {
    Object.assign(this, attributes);
  }

  get name() {
    return `${this.givenName} ${this.familyName}`;
  }

  get isPrimary() {
    return this.beneficiaryType === 'PRIMARY';
  }

  get isContingent() {
    return !this.isPrimary;
  }
}
